import type * as React from 'react';

function SvgArrowUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M21.707 15.793L12.707 6.793C12.3164 6.4024 11.6836 6.4024 11.2929 6.793L2.293 15.793C1.9024 16.1836 1.9024 16.8164 2.293 17.2071C2.4883 17.4024 2.7442 17.5001 3 17.5001C3.2558 17.5001 3.5117 17.4024 3.707 17.2071L12 8.9141L20.293 17.2071C20.4883 17.4024 20.7442 17.5001 21 17.5001C21.2558 17.5001 21.5117 17.4024 21.707 17.2071C22.0976 16.8165 22.0976 16.1837 21.707 15.793Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowUp;
